/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteGcpKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteGcpKmsKeyRequest = {
  /**
   * The ID of the key to delete.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteGcpKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGcpKmsKeySecurity$outboundSchema: z.ZodMiniType<
  DeleteGcpKmsKeySecurity$Outbound,
  DeleteGcpKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteGcpKmsKeySecurityToJSON(
  deleteGcpKmsKeySecurity: DeleteGcpKmsKeySecurity,
): string {
  return JSON.stringify(
    DeleteGcpKmsKeySecurity$outboundSchema.parse(deleteGcpKmsKeySecurity),
  );
}

/** @internal */
export type DeleteGcpKmsKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGcpKmsKeyRequest$outboundSchema: z.ZodMiniType<
  DeleteGcpKmsKeyRequest$Outbound,
  DeleteGcpKmsKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteGcpKmsKeyRequestToJSON(
  deleteGcpKmsKeyRequest: DeleteGcpKmsKeyRequest,
): string {
  return JSON.stringify(
    DeleteGcpKmsKeyRequest$outboundSchema.parse(deleteGcpKmsKeyRequest),
  );
}
